// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.software-development-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 70px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  gap: 20px;
}

.software-development-image {
  position: relative;
  width: 34%;
  order: 1;
  margin-top: 0;
}

.software-development-text {
  width: 60%;
  order: 2;
  margin-bottom: 90px;
}

.software-development-text h1 {
  font-size: 2em;
  color: #000;
  margin-bottom: 10px;
}

.software-development-text p {
  font-size: 1em;
  color: #555;
  margin-bottom: 20px;
}

.services-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  list-style: none;
  padding: 0;
}

.services-list li {
  width: 45%;
  font-size: 0.9em;
  color: #333;
}

.software-development-button {
  background-color: #00c853;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 1em;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 20px;
  transition: background-color 0.3s ease;
}

.software-development-button:hover {
  background-color: #009624;
}

@media (max-width: 768px) {
  .software-development-container {
    flex-direction: column;
    align-items: center;
    text-align: left;
    padding-top: 150px;
    gap: 20px;
  }

  .software-development-text {
    width: 130%;
    margin-top: -30px;
    order: 2;
  }

  .software-development-text h1 {
    margin-top: 20px;
    width: 125%;
    font-size: 180%;
    order: 2;
  }

  .software-development-image {
    width: 130%;
    order: 1;
  }

  .services-list li {
    width: 100%;
  }
}

@media screen and (min-width: 1380px) and (max-width: 1919px) {
  .software-development-container {
    padding: 100px;
    gap: 15px;
  }

  .software-development-text {
    margin-bottom: 100px;
    margin-right: 30px;
  }

  .software-development-text h1 {
    font-size: 1.8em;
  }

  .software-development-text p {
    font-size: 0.95em;
  }

  .software-development-image {
    width: 31%;
  }

  .services-list li {
    width: 48%;
    font-size: 0.85em;
  }

  .software-development-button {
    padding: 8px 18px;
    font-size: 0.95em;
  }
}

@media screen and (min-width: 1920px) {
  .software-development-container {
    padding: 80px;
    gap: 25px;
  }

  .software-development-text {
    margin-bottom: 100px;
  }

  .software-development-text h1 {
    font-size: 2.2em;
  }

  .software-development-text p {
    font-size: 1.1em;
  }

  .software-development-image {
    width: 32%;
  }

  .services-list li {
    width: 45%;
    font-size: 1em;
  }

  .software-development-button {
    padding: 12px 24px;
    font-size: 1.1em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SoftwareDevelopment/SoftwareDevelopment.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,cAAc;IACd,SAAS;EACX;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF","sourcesContent":[".software-development-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 70px;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  gap: 20px;\n}\n\n.software-development-image {\n  position: relative;\n  width: 34%;\n  order: 1;\n  margin-top: 0;\n}\n\n.software-development-text {\n  width: 60%;\n  order: 2;\n  margin-bottom: 90px;\n}\n\n.software-development-text h1 {\n  font-size: 2em;\n  color: #000;\n  margin-bottom: 10px;\n}\n\n.software-development-text p {\n  font-size: 1em;\n  color: #555;\n  margin-bottom: 20px;\n}\n\n.services-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  list-style: none;\n  padding: 0;\n}\n\n.services-list li {\n  width: 45%;\n  font-size: 0.9em;\n  color: #333;\n}\n\n.software-development-button {\n  background-color: #00c853;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  font-size: 1em;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 20px;\n  transition: background-color 0.3s ease;\n}\n\n.software-development-button:hover {\n  background-color: #009624;\n}\n\n@media (max-width: 768px) {\n  .software-development-container {\n    flex-direction: column;\n    align-items: center;\n    text-align: left;\n    padding-top: 150px;\n    gap: 20px;\n  }\n\n  .software-development-text {\n    width: 130%;\n    margin-top: -30px;\n    order: 2;\n  }\n\n  .software-development-text h1 {\n    margin-top: 20px;\n    width: 125%;\n    font-size: 180%;\n    order: 2;\n  }\n\n  .software-development-image {\n    width: 130%;\n    order: 1;\n  }\n\n  .services-list li {\n    width: 100%;\n  }\n}\n\n@media screen and (min-width: 1380px) and (max-width: 1919px) {\n  .software-development-container {\n    padding: 100px;\n    gap: 15px;\n  }\n\n  .software-development-text {\n    margin-bottom: 100px;\n    margin-right: 30px;\n  }\n\n  .software-development-text h1 {\n    font-size: 1.8em;\n  }\n\n  .software-development-text p {\n    font-size: 0.95em;\n  }\n\n  .software-development-image {\n    width: 31%;\n  }\n\n  .services-list li {\n    width: 48%;\n    font-size: 0.85em;\n  }\n\n  .software-development-button {\n    padding: 8px 18px;\n    font-size: 0.95em;\n  }\n}\n\n@media screen and (min-width: 1920px) {\n  .software-development-container {\n    padding: 80px;\n    gap: 25px;\n  }\n\n  .software-development-text {\n    margin-bottom: 100px;\n  }\n\n  .software-development-text h1 {\n    font-size: 2.2em;\n  }\n\n  .software-development-text p {\n    font-size: 1.1em;\n  }\n\n  .software-development-image {\n    width: 32%;\n  }\n\n  .services-list li {\n    width: 45%;\n    font-size: 1em;\n  }\n\n  .software-development-button {\n    padding: 12px 24px;\n    font-size: 1.1em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
